export default __webpack_public_path__ + "static/media/fc2.6dc351b4.jpg";